import Vue from 'vue';
import moment from 'moment';
import firebase from 'firebase';

Vue.filter('formatDate', (value: any, format: string = 'MM/DD/YYYY HH:mm'): string => {
	return moment(value.toMillis()).format(format);
});

Vue.filter('toTimestamp', (value: any) => {
	return new firebase.firestore.Timestamp(value._seconds, value._nanoseconds);
});

Vue.filter('capitalize', (value: any) => (value ? `${value.toString().charAt(0).toUpperCase()}${value.slice(1)}` : ''));

export default {
	// Get value of nested 1st level property (not recursively)
	getNestedValue(obj: object, nestedString: string): any {
		return nestedString.split('.').reduce(function (p, prop) {
			return p[prop];
		}, obj);
	},
};
